export default __webpack_public_path__ + "static/media/dog_v1.cf771240.png";